import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Notyf } from 'notyf';
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";
import exportValue from "../apiconfig";
import Left_panel from './Left_panel';
import Sub_header from './Sub_header';
import EChartsReact from "echarts-for-react";
import { useTheme } from '@material-ui/core/styles';
import { useSelector, useDispatch } from "react-redux";
import { DashboardLists } from "../redux/actions/DashboardActions";
import { CanvasJSChart } from 'canvasjs-react-charts'
import Chart from 'chart.js/auto';
import ReactLoading from 'react-loading';
const Ndr_dashboard = () => {
  const { palette } = useTheme()
  const inputRef = useRef(null);
  let navigate = useNavigate();
  const loginDetail = localStorage.getItem('admin_login');
  console.log("e  ----=> ", loginDetail);
  
  if (loginDetail == null) {
    console.log(" not valid ");
  
  }
  const [dimensionState, setdimensionState] = React.useState([])
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [rstate, setRState] = useState({
    suggestions: [],
    text: "",
  });
  const [focusedIndex, setfocusedIndex] = React.useState(-1);
  const [customeridstate, setcustomeridstate] = React.useState({ customer_id: "" })
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 7);

  // Format the start date and end date as strings
  const formattedStartDate = startDate.toISOString().split('T')[0];
  const formattedEndDate = new Date().toISOString().split('T')[0];
  const [date, setdate] = useState({ start_date: formattedStartDate, end_date: formattedEndDate })
  const [ndrSummary, setNdrSummary] = useState({});
const [loading, setLoading] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector('.home-section');
    if (homeSection) {
      homeSection.classList.toggle('sidebar-closed');
    }
  };
 
  const handleChange = (e) => {
    setdate({ ...date, [e.target.name]: e.target.value })
  }

  React.useEffect(() => {
    fetchNdrSummary();
  }, [date ,customeridstate.customer_id ]);
  
  const fetchNdrSummary = async () => {
    try {
      setLoading(true);
      let full_api = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/getNdrSummary`;
      const payload = {
        start_date: date.start_date,
        end_date: date.end_date,
      };
      
      if (customeridstate.customer_id) {
        payload.customer_id = customeridstate.customer_id;
      }
      const res = await axios.post(full_api, payload,{ headers: exportValue.headers });
      if (res?.data?.data) {
        setNdrSummary(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching NDR summary", err);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    customerProfile()
}, [])
  const customerProfile = () => {
    let full_api = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/customer_profile`;
    let sendData = {};

    axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
      setdimensionState(res.data.output);
      console.log("rnmmmmm", res);
    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      console.log("----error:   ", e);
    })
  }

  const customerHandle = (e) => {
    const value = e.target.value;
    let suggestions = [];
  
    if (value.length > 0) {
      const regex = new RegExp(`^${value}`, "i");
      suggestions = dimensionState.filter(sub =>
        (sub.email && regex.test(sub.email)) ||
        (sub.full_name && regex.test(sub.full_name))
      );
    } else {
      setcustomeridstate({
        customer_id: "",
      });
      // remove customer_id from URL
     
    }
  
    setRState({
      suggestions,
      text: value,
    });
  };

  function selectedText(value) {
    if (!value || !value.full_name || !value.customer_id) {
      return; // Exit early if value is invalid
    }
  
    setRState(() => ({
      text: value.full_name,
      suggestions: [],
    }));
  
    setcustomeridstate((prev) => ({
      ...prev,
      customer_id: value.customer_id,
    }));
  
   
  }
  

  // const selectDate=(e)=>{
  //   setDateState({...setDate , date:e.target.value})
  // }
  const handleKeyDown = (e) => {
    if (rstate.suggestions.length === 0) return;
  
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const nextIndex = (focusedIndex + 1) % rstate.suggestions.length;
      setfocusedIndex(nextIndex);
    } 
    else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prevIndex = (focusedIndex - 1 + rstate.suggestions.length) % rstate.suggestions.length;
      setfocusedIndex(prevIndex);
    } 
    else if (e.key === 'Enter') {
      e.preventDefault();
  
      const selectedItem = 
        focusedIndex !== -1 ? rstate.suggestions[focusedIndex] : rstate.suggestions[0];
  
      if (selectedItem) {
        selectedText(selectedItem);
      }
    }
  };
  
  return (
    <div>
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <section class="home-section">
        <div class="">
          <div class="">
            <Sub_header />
            <section className="mt-2">
            <h5 className="">NDR Dashboard</h5>
            <div className="row mb-2">
              <div className="col-4">
              <div className=" position-relative">
                  <input
                    type="text"
                    name="customer_name"
                    className="form-control"
                    placeholder="Enter Customer Name"
                    onChange={customerHandle}
                    value={rstate.text}
                    autoComplete="off"
                    onKeyDown={handleKeyDown}
                    ref={inputRef}
                  />
                
                  {rstate.suggestions.length > 0 && (
                    <ul className="list-group position-absolute w-100 z-3" style={{ maxHeight: "200px", overflowY: "auto", top: "100%" }}>
                      {rstate.suggestions.map((item, index) => (
                        <li
                          key={index}
                          onClick={() => selectedText(item)}
                          className={`list-group-item list-group-item-action ${index === focusedIndex ? 'active' : ''}`}
                          style={{
                            cursor: "pointer",
                            fontSize: "14px",
                            padding: "8px 15px",
                          }}
                        >
                          <strong>{item.full_name}</strong> <br />
                          <small className="text-muted">{item.email}</small>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div className="col-4">  <input className="form-control" type="date" name="start_date" onChange={(e) => handleChange(e)} value={date.start_date}></input></div>
              <div className="col-4">
                <input className="form-control" type="date" onChange={(e) => handleChange(e)} name="end_date" value={date.end_date}></input>
              </div>
              <div class="container py-4">
  
              {loading ? (
  <ReactLoading type="spin" color="#000" height={50} width={50} />
) : Object.keys(ndrSummary).length === 0 ? (
  <div className="text-center mt-3">No data available</div>
) : (
  Object.entries(ndrSummary).map(([carrierName, summary]) => (
    <section className="mb-3" key={carrierName}>
      <h4>{carrierName}</h4>
      <div className="row g-4" id="ndrCardsContainer">
        {Object.entries(summary).map(([metric, count]) => (
          <div className="col-md col-lg" key={metric}>
            <div className="card p-3 ndr-card">
              <div className="d-flex justify-content-between">
                <div>
                  <div className="ndr-metric">{metric}</div>
                  <div className="ndr-count">{count}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  ))
)}

   
</div>
            </div>
            </section>
          
          </div>
        </div>
      </section>

    </div>

  )
}

export default Ndr_dashboard